import { render, staticRenderFns } from "./EditorSectionNav.vue?vue&type=template&id=88c8fd04&scoped=true"
import script from "./EditorSectionNav.vue?vue&type=script&lang=js"
export * from "./EditorSectionNav.vue?vue&type=script&lang=js"
import style0 from "./EditorSectionNav.vue?vue&type=style&index=0&id=88c8fd04&prod&lang=scss&scoped=true"
import style1 from "./EditorSectionNav.vue?vue&type=style&index=1&id=88c8fd04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c8fd04",
  null
  
)

export default component.exports